import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TotemComponent } from './pages/totem/totem.component';
import { DisplayComponent } from './pages/display/display.component';
import { DisplayOptionsComponent } from './pages/display/display-options/display-options.component';

const routes: Routes = [
  { path: 'client/totem/:id', component: TotemComponent },
  { path: 'client/display/:id', component: DisplayComponent },
  { path: 'client/display/display-options/:id', component: DisplayOptionsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})

export class ClientRoutingModule { }